import Swiper from 'swiper';

const installmentSliders = Array.from(document.querySelectorAll('.j-installment-swiper-slider'));

if (installmentSliders.length) {
    installmentSliders.forEach((slider) => {
        new Swiper(slider, { // eslint-disable-line
            wrapperClass : 'j-installment-swiper-slider-wrap',
            slideClass   : 'j-installment-swiper-slider-slide',
            grabCursor   : true,
            speed        : 500,
            slidesPerView: 'auto',
            scrollbar    : {
                el       : '.j-installment-swiper-slider-scroll',
                draggable: true
            }
        });
    });
}
